import './alert-banner.scss';

class AlertBanner {
    constructor (element) {
        this.$root = element;
        this.$hideBanner = this.$root.querySelector('[data-alert-banner="hide"]');
    }

    initialize () {
        this.$root.dataset.alertBannerActive = true;
        this.setHeight();

        window.addEventListener('resize', () => {
            this.setHeight();
        });

        if (this.$hideBanner) {
            this.$hideBanner.onclick = () => {
                this.$root.dataset.alertBannerActive = false;
                document.cookie = 'hide_alert_banner=true; path=/; SameSite=Lax';

                this.setHeight();
            };
        }
    }

    setHeight () {
        document.body.style.setProperty('--siteheader-top', `${this.$root.clientHeight}px`);
    }
}

export { AlertBanner };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-alert-banner="root"]:not([data-init="true"])');

        $$roots.forEach($root => {
            const $rootAPI = new AlertBanner($root);
            $rootAPI.initialize();
            $root.setAttribute('data-init', 'true');
        });
    }
});
